export enum FractionsConstants {
  GET_ALL_FRACTIONS_REQUEST = 'GET_ALL_FRACTIONS_REQUEST',
  GET_ALL_FRACTIONS_SUCCESS = 'GET_ALL_FRACTIONS_SUCCESS',
  GET_ALL_FRACTIONS_FAILED = 'GET_ALL_FRACTIONS_FAILED',

  GET_FRACTION_PICTURES_REQUEST = 'GET_FRACTION_PICTURES_REQUEST',
  GET_FRACTION_PICTURES_SUCCESS = 'GET_FRACTION_PICTURES_SUCCESS',
  GET_FRACTION_PICTURES_FAILED = 'GET_FRACTION_PICTURES_FAILED',
}
